export default {
  'Your win': 'Os seus ganhos',
  'Select skins that you want to take': 'Seleccione as capas que quer receber',
  'By price': 'Por preço',
  '(Autotrade will receive after 10 minutes)': '(O Autotrade irá receber após 10 minutos)',
  ACCEPT: 'Confirmar',
  'SELECT ALL': 'SELECT ALL',
};
